import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MessageDetailStore } from './message-detail.store';
import { Observable } from 'rxjs';
import { LanguageService } from '../../../core/services/language/language.service';
import { SettingsQuery } from '../settings/settings.query';
import { CompanyQuery } from '../company/company.query';
import { UserQuery } from '../user/user.query';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class MessageDetailService {
    constructor(
        private messageDetailStore: MessageDetailStore,
        private http: HttpClient,
        private languageService: LanguageService,
        private settingsQuery: SettingsQuery,
        private companyQuery: CompanyQuery,
        private userQuery: UserQuery,
        private apiService: ApiService
    ) {}

    /*-----------*/
    /** UPDATES */
    /*----------*/

    /**
     * Crea un mensaje y la carga en la Store a partir de datos de API
     */
    updateMessage(message) {
        this.messageDetailStore.update({
            id: message.MessageID,
            gid: message.MessageGID,
            type: message.MessageType,
            colorIcon: message.MessageColorIcon,
            title: message.MessageTitle,
            subtitle: message.MessageSubTitle,
            promotionText1: message.MessagePromotionText_1,
            promotionText2: message.MessagePromotionText_2,
            promotionText3: message.MessagePromotionText_3,
            promotionText4: message.MessagePromotionText_4,
            promotionText5: message.MessagePromotionText_5,
            promotionText6: message.MessagePromotionText_6,
            promotionText7: message.MessagePromotionText_7,
            buttonText: message.MessageButtonText,
            buttonAction: message.MessageButtonAction,
            text1: message.MessageText_1,
            text2: message.MessageText_2,
            linkText1: message.MessageLinkText_1,
            linkUrl1: message.MessageLinkURL_1,
            linkText2: message.MessageLinkText_2,
            linkUrl2: message.MessageLinkURL_2,
            linkText3: message.MessageLinkText_3,
            linkUrl3: message.MessageLinkURL_3,
        });
    }

    /*---------------*/
    /** LLAMADAS API */
    /*---------------*/

    /**
     * Llamada api para obtener los detalles de un mensaje selecciona
     */
    private getMessageApi(
        systemKey: string,
        clientToken: string,
        messageID: string
    ): Observable<any> {
        let params = new HttpParams();
        params = params.append('systemKey', systemKey);
        params = params.append('ClientToken', clientToken);
        params = params.append('MessageID', messageID);
        params = params.append('Cmd', 'c1052');
        params = params.append('Locale', this.languageService.getLocale());

        return this.apiService.callApi(params);
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    /**
     * Llama a la API para obtener los detalles de un mensaje
     */
    async getMessage(messageId: string) {
        /** Comprobamos si la clínica ya está inizializada */
        const messageData = await this.getMessageApi(
            this.settingsQuery.systemKeyURL,
            this.userQuery.tokenId,
            messageId
        ).toPromise();

        /**
         * Cargamos los detalles de la clínica a la Store
         */
        this.updateMessage(messageData.Messages[0]);
    }

    resetStore() {
        this.messageDetailStore.reset();
    }
}
